import { Component, OnInit, Inject, Input } from '@angular/core';
import { Menu } from '../model/menu.model';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  @Input("MenuInfoPromise") MenuPromise: Promise<Menu[]>;

  baseurl: string;

  private menu: Menu[];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private routeActivated: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  OnLogoClick() {
    this.router.navigate(['/portal']);
  }
}
